// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"vp-z","badgeLink":"wp-z","category":"xp-z"};